import { sql } from 'drizzle-orm';
import { index, integer, jsonb, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { relations } from 'drizzle-orm';
import { addresses } from './addresses.js';
import { user } from './auth.js';
import { patientEncounters } from './patients.js';
import { userAccessLocation } from './user-access-location.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const locations = pgTable('location', {
    id: uuidv7('id').primaryKey(),
    cyproOldId: integer('cypro_old_id'),
    name: text('name').notNull(),
    code: text('code').notNull().unique(),
    logo: text('logo'),
    createdAt: timestamp('created_at').notNull(),
    metadata: text('metadata'),
    address: jsonb('address').$type(),
});
export const locationRelations = relations(locations, ({ many }) => ({
    sections: many(sections),
    wards: many(wards),
    userAccessLocations: many(userAccessLocation),
}));
export const SectionType = z.enum(['outpatients', 'pharmacy']);
export const sectionType = pgEnum('section_type', [SectionType.enum.outpatients, SectionType.enum.pharmacy]);
export const SectionStatus = z.enum(['active', 'inactive']);
export const sectionStatus = pgEnum('section_status', [SectionStatus.enum.active, SectionStatus.enum.inactive]);
export const sections = pgTable('section', {
    id: uuidv7('id').primaryKey(),
    cyproOldId: integer('cypro_old_id'),
    name: text('name').notNull(),
    code: text('code').notNull().unique(),
    locationId: uuid('location_id')
        .notNull()
        .references(() => locations.id, { onDelete: 'cascade' }),
    type: sectionType('type').notNull().default(SectionType.enum.outpatients),
    status: sectionStatus('status').default(SectionStatus.enum.active),
    costCenterNumber: text('cost_center_number').notNull().unique(),
    orderNumber: text('order_number'),
    herstellerNumber: text('hersteller_number'),
    movementType: text('movement_type'),
    deliveryAddress: jsonb('delivery_address').$type(),
    ikNumber: text('ik_number'),
    addressId: uuid('address_id').references(() => addresses.id, { onDelete: 'set null' }),
    ...timestamps(),
    ...userActions(),
}, t => [
    index('idx_sections_active').on(t.deletedAt).where(sql `${t.deletedAt} IS NULL`),
]);
export const seactionRelations = relations(sections, ({ one, many }) => ({
    location: one(locations, {
        fields: [sections.locationId],
        references: [locations.id],
    }),
    address: one(addresses, {
        fields: [sections.addressId],
        references: [addresses.id],
    }),
    created: one(user, {
        fields: [sections.createdBy],
        references: [user.id],
    }),
    wards: many(wards),
    userAccessLocation: many(userAccessLocation),
    patientsEncounters: many(patientEncounters),
}));
export const WardStatus = z.enum(['active', 'inactive']);
export const wardStatus = pgEnum('ward_status', [WardStatus.enum.active, WardStatus.enum.inactive]);
export const wards = pgTable('ward', {
    id: uuidv7('id').primaryKey(),
    cyproOldId: integer('cypro_old_id'),
    name: text('name').notNull(),
    code: text('code').notNull().unique(),
    locationId: uuid('location_id')
        .notNull()
        .references(() => locations.id, { onDelete: 'cascade' }),
    sectionId: uuid('section_id')
        .notNull()
        .references(() => sections.id, { onDelete: 'cascade' }),
    status: wardStatus('status').default(WardStatus.enum.active),
    costCenterNumber: text('cost_center_number').notNull().unique(),
    orderNumber: text('order_number'),
    movementType: text('movement_type'),
    ...timestamps(),
    ...userActions(),
}, t => [
    index('idx_wards_active').on(t.deletedAt).where(sql `${t.deletedAt} IS NULL`),
]);
export const wardRelations = relations(wards, ({ one, many }) => ({
    location: one(locations, {
        fields: [wards.locationId],
        references: [locations.id],
    }),
    created: one(user, {
        fields: [wards.createdBy],
        references: [user.id],
    }),
    section: one(sections, {
        fields: [wards.sectionId],
        references: [sections.id],
    }),
    userAccessLocation: many(userAccessLocation),
    patientsEncounters: many(patientEncounters),
}));
//# sourceMappingURL=locations.js.map